import { PreviewColumnT } from 'routes/Cellar/types';

export const includesGeoColumns = (
    columns: ResponseColumnT[] | PreviewColumnT[],
) =>
    columns.some(
        (column) => column.type === 'coordinates' || column.type === 'polygon',
    );
